import dynamic from 'next/dynamic';

import { breakUpLongTask } from '@utils/breakUpLongTasks';
export default dynamic(breakUpLongTask(() => import(/* webpackChunkName:"Quiz" */ './Quiz')));

export type { IQuiz } from './Quiz';
